import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'pnr';
  @ViewChild(MatAccordion) accordion: MatAccordion;
  showFiller = false;

  ngOnInit(): void{

  }
}
